import { Component, OnInit } from '@angular/core';
import { DeoZaResenjeZaGo } from './deo-za-resenje-za-go';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalContainerService, BaseModalUpdateComponent, BaseInlineContainer, BaseEntity, InlineContainerService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { List } from 'immutable';

@Component({
  selector: 'yt-deo-za-resenje-za-go-update-container',
  templateUrl: './deo-za-resenje-za-go-update-container.component.html',
  providers: [
    InlineContainerService
  ] 
})
export class DeoZaResenjeZaGoUpdateContainer<T extends BaseEntity> 
extends BaseInlineContainer<T> {

  constructor(inlineContainerService: InlineContainerService<T>,
    activatedRoute: ActivatedRoute,
    userService: UserService){
super(inlineContainerService, activatedRoute, userService);
}

tempItems: List<T>

setItems(items){
this.tempItems = items;
}
}
